/* Lunabee redesign — shared behaviours: quick add-to-cart + countdowns */
(function () {
  "use strict";

  document.documentElement.classList.add("lb-js");

  /* ---------- Toast ---------- */
  function toast(msg, isError) {
    var t = document.createElement("div");
    t.className = "lb-toast" + (isError ? " lb-toast--error" : "");
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("is-in"); });
    setTimeout(function () { t.classList.remove("is-in"); setTimeout(function () { t.remove(); }, 300); }, 2600);
  }

  /* ---------- Money formatting (Shopify format string) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(/[^0-9-]/g, "");
    var fmt = (format || "Rs. {{amount}}").replace(/<[^>]+>/g, "");
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delim(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      if (isNaN(number) || number == null) return "0";
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var frac = parts[1] ? decimal + parts[1] : "";
      return whole + frac;
    }
    var value;
    switch ((fmt.match(re) || [])[1]) {
      case "amount_no_decimals": value = delim(cents, 0); break;
      case "amount_with_comma_separator": value = delim(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = delim(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = delim(cents, 2, " ", "."); break;
      case "amount_with_apostrophe_separator": value = delim(cents, 2, "'", "."); break;
      default: value = delim(cents, 2);
    }
    return fmt.replace(re, value);
  }

  /* ---------- Add-to-cart button state ---------- */
  function setAddedState(btn, added) {
    if (added) {
      if (!btn.dataset.lbLabel) btn.dataset.lbLabel = btn.textContent.trim();
      btn.textContent = btn.dataset.addedLabel || "Added";
      btn.classList.add("is-added");
    } else {
      if (btn.dataset.lbLabel) btn.textContent = btn.dataset.lbLabel;
      btn.classList.remove("is-added");
    }
  }

  /* ---------- Global sticky cart bar ---------- */
  var _cartBarChecked = false, _cartBarOk = false;
  function cartBarAllowed() {
    if (_cartBarChecked) return _cartBarOk;
    _cartBarChecked = true;
    var bar = document.querySelector("[data-lb-cartbar]");
    if (!bar) { _cartBarOk = false; return false; }
    /* pages with their own bottom bar, or the cart page, drop the global bar */
    var tmpl = document.documentElement.getAttribute("data-template");
    if (tmpl === "cart" || document.querySelector(".lb-pdp__staybar, .lb-bb__bar")) {
      bar.parentNode && bar.parentNode.removeChild(bar);
      _cartBarOk = false; return false;
    }
    _cartBarOk = true; return true;
  }
  function updateCartBar(cart) {
    if (!cartBarAllowed()) return;
    var bar = document.querySelector("[data-lb-cartbar]");
    if (!bar) return;
    var show = cart.item_count > 0;
    bar.classList.toggle("is-visible", show);
    bar.style.transform = show ? "translateY(0)" : ""; /* inline wins any cascade */
    bar.setAttribute("aria-hidden", String(!show));
    if (!show) return;
    var cnt = bar.querySelector("[data-cartbar-count]");
    if (cnt) cnt.textContent = cart.item_count;
    var names = bar.querySelector("[data-cartbar-names]");
    if (names) {
      var titles = (cart.items || []).map(function (i) { return i.product_title; });
      var txt = titles.slice(0, 2).join(", ");
      if (titles.length > 2) txt += " +" + (titles.length - 2) + " more";
      names.textContent = txt;
    }
    var total = bar.querySelector("[data-cartbar-total]");
    if (total) total.textContent = formatMoney(cart.total_price, bar.getAttribute("data-money-format"));
  }

  /* ---------- Update header cart (count + subtotal) + reflect button states ---------- */
  var _cartBusy = false, _cartQueued = false;
  function refreshCart() {
    if (_cartBusy) { _cartQueued = true; return; }
    _cartBusy = true;
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(".lb-hdr__cart-count").forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll("[data-cartbar-count-tab]").forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
        var fmtEl = document.querySelector("[data-money-format]");
        var fmt = fmtEl ? fmtEl.getAttribute("data-money-format") : null;
        document.querySelectorAll("[data-lb-cart-total]").forEach(function (el) { el.textContent = formatMoney(cart.total_price, fmt); });
        // reflect which quick-add buttons are in the cart
        var inCart = {};
        (cart.items || []).forEach(function (it) { inCart[it.id] = true; });
        document.querySelectorAll("[data-lb-add]").forEach(function (btn) {
          var id = btn.getAttribute("data-lb-add");
          setAddedState(btn, !!(id && inCart[Number(id)]));
        });
        updateCartBar(cart);
      })
      .catch(function () {})
      .finally(function () {
        _cartBusy = false;
        if (_cartQueued) { _cartQueued = false; refreshCart(); }
      });
  }

  /* ---------- Refresh on ANY cart mutation (native theme add, quick view, drawer, our quick-add) ---------- */
  var CART_MUTATION = /\/cart\/(add|change|update|clear)/i;
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function () {
      var a0 = arguments[0];
      var url = typeof a0 === "string" ? a0 : (a0 && a0.url) || "";
      var p = _fetch.apply(this, arguments);
      if (CART_MUTATION.test(url)) p.then(function () { setTimeout(refreshCart, 80); }).catch(function () {});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(url || "")) {
      this.addEventListener("load", function () { setTimeout(refreshCart, 80); });
    }
    return _open.apply(this, arguments);
  };
  // Also honour common theme cart events as a backup
  ["cart:updated", "cart:refresh", "cart:change", "cart:build", "ajaxCart:afterCartLoad", "product:added", "variant:added"].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refreshCart, 80); });
  });

  /* ---------- Quick add ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-lb-add]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-lb-add");
    if (!id) { toast("Choose options on the product page", true); return; }
    if (btn.classList.contains("is-loading")) return;
    btn.classList.add("is-loading");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(btn.getAttribute("data-lb-qty")) || 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () { refreshCart(); toast("Added to cart"); })     // refreshCart flips this button to "✓ Added"
      .catch(function () { toast("Sold out or needs options — open the product", true); })
      .finally(function () { btn.classList.remove("is-loading"); });
  });

  /* reflect current cart on first load (shows "Added" for items already in cart) */
  if (document.readyState !== "loading") refreshCart();
  else document.addEventListener("DOMContentLoaded", refreshCart);

  /* ---------- Wishlist (localStorage of product handles) ---------- */
  var WKEY = "lb-wishlist";
  function wlist() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wsave(l) { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {} }
  function wpaint() {
    var l = wlist();
    document.querySelectorAll("[data-lb-wish]").forEach(function (b) {
      var on = l.indexOf(b.getAttribute("data-lb-wish")) > -1;
      b.classList.toggle("is-wished", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
      if (b.hasAttribute("data-lb-wish-label")) {
        b.textContent = on ? (b.getAttribute("data-saved") || "♥ Saved") : (b.getAttribute("data-unsaved") || "♡ Save");
      }
    });
    document.querySelectorAll("[data-lb-wish-count]").forEach(function (el) {
      el.textContent = l.length; el.hidden = l.length === 0;
    });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-lb-wish]");
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute("data-lb-wish");
    if (!h) return;
    var l = wlist(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.push(h);
    wsave(l); wpaint();
    document.dispatchEvent(new CustomEvent("lb:wishlist", { detail: { list: l } }));
  });
  document.addEventListener("lb:content", wpaint);
  if (document.readyState !== "loading") wpaint();
  else document.addEventListener("DOMContentLoaded", wpaint);

  /* ---------- Quick-add size picker (multi-size products) ---------- */
  var sizeSheetSource = null;   /* the card's Add button that opened the sheet */
  function closeSizeSheet() {
    var sheet = document.querySelector("[data-lb-sizesheet]");
    if (!sheet) return;
    sheet.classList.remove("is-open");
    sheet.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("lb-drawer-lock");
  }
  document.addEventListener("click", function (e) {
    /* open the picker for a multi-size card */
    var choose = e.target.closest("[data-lb-choose]");
    if (choose) {
      e.preventDefault();
      var sheet = document.querySelector("[data-lb-sizesheet]");
      if (!sheet) return;
      var variants;
      try { variants = JSON.parse(choose.getAttribute("data-variants") || "[]"); } catch (err) { variants = []; }
      if (!variants.length) { toast("Open the product to choose a size", true); return; }
      var titleEl = sheet.querySelector("[data-sizesheet-title]");
      if (titleEl) titleEl.textContent = choose.getAttribute("data-title") || "Choose a size";
      var img = sheet.querySelector("[data-sizesheet-img]");
      if (img) { var src = choose.getAttribute("data-img"); if (src) { img.src = src; img.style.display = ""; } else { img.style.display = "none"; } }
      var wrap = sheet.querySelector("[data-sizesheet-sizes]");
      wrap.innerHTML = "";
      variants.forEach(function (v) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "lb-sizesheet__size";
        b.setAttribute("data-lb-add", v.id);   /* reuse the quick-add flow */
        b.setAttribute("data-added-label", "Added ✓");
        b.textContent = v.t;
        wrap.appendChild(b);
      });
      sizeSheetSource = choose;
      sheet.classList.add("is-open");
      sheet.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("lb-drawer-lock");
      return;
    }
    /* close controls */
    if (e.target.closest("[data-sizesheet-close]")) { closeSizeSheet(); return; }
    /* picking a size adds it (handled by the quick-add listener); flip the
       originating card button to "Added" and close the sheet */
    var chip = e.target.closest("[data-lb-sizesheet] [data-lb-add]");
    if (chip) {
      var vid = chip.getAttribute("data-lb-add");
      var src = sizeSheetSource;
      setTimeout(function () {
        fetch("/cart.js", { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var inCart = (cart.items || []).some(function (i) { return String(i.id) === String(vid); });
            if (inCart && src) setAddedState(src, true);
          })
          .catch(function () {})
          .finally(function () { closeSizeSheet(); });
      }, 650);
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSizeSheet(); });

  /* ---------- Copy coupon code ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-lb-copy]");
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute("data-lb-copy");
    function done() {
      var orig = btn.dataset.copyOrig || btn.textContent;
      btn.dataset.copyOrig = orig;
      btn.textContent = "Copied ✓";
      btn.classList.add("is-copied");
      toast("Copied code " + code);
      setTimeout(function () { btn.textContent = btn.dataset.copyOrig; btn.classList.remove("is-copied"); }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code); done(); });
    } else { fallbackCopy(code); done(); }
  });
  function fallbackCopy(text) {
    var ta = document.createElement("textarea");
    ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select();
    try { document.execCommand("copy"); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* ---------- Countdown ---------- */
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  function initCountdowns() {
    document.querySelectorAll("[data-lb-countdown]").forEach(function (el) {
      var raw = el.getAttribute("data-lb-countdown");
      var target = raw ? new Date(raw).getTime() : NaN;
      function next() {
        var now = Date.now();
        var end = target;
        if (isNaN(end) || end <= now) {
          // fall back to (or roll over to) end of today, local time
          var d = new Date(); d.setHours(23, 59, 59, 999); end = d.getTime();
          if (!isNaN(target) && target > now) end = target;
        }
        var diff = Math.max(0, end - now);
        var s = Math.floor(diff / 1000);
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
        var days = Math.floor(h / 24);
        el.textContent = (days > 0 ? days + "d " : "") + pad(h % 24) + ":" + pad(m) + ":" + pad(sec);
      }
      next();
      setInterval(next, 1000);
    });
  }
  if (document.readyState !== "loading") initCountdowns();
  else document.addEventListener("DOMContentLoaded", initCountdowns);

  /* ---------- Hero slider ---------- */
  function initHeroSliders() {
    document.querySelectorAll("[data-lb-hero]").forEach(function (root) {
      var track = root.querySelector("[data-hero-track]");
      var slides = root.querySelectorAll("[data-hero-slide]");
      if (!track || slides.length <= 1) return;
      var dots = root.querySelectorAll("[data-hero-dot]");
      var total = slides.length;
      var i = 0, timer = null;
      var autoplay = root.getAttribute("data-autoplay") === "true";
      var interval = parseInt(root.getAttribute("data-interval"), 10) || 6000;

      function go(n) {
        i = (n + total) % total;
        track.style.transform = "translateX(-" + (i * 100) + "%)";
        dots.forEach(function (d, k) { d.classList.toggle("is-active", k === i); });
      }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }
      function start() { if (autoplay) { stop(); timer = setInterval(next, interval); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      var nx = root.querySelector("[data-hero-next]"); if (nx) nx.addEventListener("click", function () { next(); start(); });
      var pv = root.querySelector("[data-hero-prev]"); if (pv) pv.addEventListener("click", function () { prev(); start(); });
      dots.forEach(function (d) { d.addEventListener("click", function () { go(parseInt(d.getAttribute("data-hero-dot"), 10)); start(); }); });

      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);

      // touch swipe
      var x0 = null;
      root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      root.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
        x0 = null; start();
      });

      // In the theme editor, jump to the slide being edited
      if (window.Shopify && Shopify.designMode) {
        root.addEventListener("shopify:block:select", function (e) {
          var idx = Array.prototype.indexOf.call(slides, e.target.closest("[data-hero-slide]"));
          if (idx > -1) { stop(); go(idx); }
        });
        root.addEventListener("shopify:block:deselect", start);
      }

      go(0); start();
    });
  }
  if (document.readyState !== "loading") initHeroSliders();
  else document.addEventListener("DOMContentLoaded", initHeroSliders);

  /* ---------- Mobile drawer ---------- */
  function drawerSet(open) {
    var d = document.querySelector("[data-lb-drawer]");
    if (!d) return;
    d.classList.toggle("is-open", open);
    d.setAttribute("aria-hidden", String(!open));
    document.documentElement.classList.toggle("lb-drawer-lock", open);
    var burger = document.querySelector("[data-lb-drawer-open]");
    if (burger) burger.setAttribute("aria-expanded", String(open));
    if (open) { var c = d.querySelector(".lb-drawer__close"); if (c) c.focus(); }
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-lb-drawer-open]")) { drawerSet(true); return; }
    if (e.target.closest("[data-lb-drawer-close]")) { drawerSet(false); return; }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") drawerSet(false);
  });
  window.addEventListener("resize", function () {
    if (window.innerWidth > 900) drawerSet(false);
  });

  /* ---------- Nav dropdowns (tap to open; second tap follows a real link) ---------- */
  document.addEventListener("click", function (e) {
    /* second-level flyout parents (tap to open; second tap follows a real link) */
    var subLink = e.target.closest("[data-lb-dd-sub] > .lb-hdr__dd-link--parent");
    if (subLink) {
      var subItem = subLink.closest("[data-lb-dd-sub]");
      var subOpen = subItem.classList.contains("is-open");
      var subHref = subLink.getAttribute("href") || "";
      if (!subOpen || subHref === "" || subHref === "#") {
        e.preventDefault();
        subItem.parentElement.querySelectorAll("[data-lb-dd-sub].is-open").forEach(function (o) { if (o !== subItem) o.classList.remove("is-open"); });
        subItem.classList.toggle("is-open", !subOpen);
        subLink.setAttribute("aria-expanded", String(!subOpen));
      }
      return;
    }
    var parentLink = e.target.closest("[data-lb-dd] > .lb-hdr__nav-link--parent");
    var openItems = document.querySelectorAll("[data-lb-dd].is-open");
    if (parentLink) {
      var item = parentLink.closest("[data-lb-dd]");
      var isOpen = item.classList.contains("is-open");
      var href = parentLink.getAttribute("href") || "";
      var dead = href === "" || href === "#";
      if (!isOpen || dead) {
        e.preventDefault();
        openItems.forEach(function (o) { if (o !== item) { o.classList.remove("is-open"); o.querySelector("a").setAttribute("aria-expanded", "false"); } });
        item.classList.toggle("is-open", !isOpen);
        parentLink.setAttribute("aria-expanded", String(!isOpen));
      }
      return; // second tap on a real link navigates naturally
    }
    if (!e.target.closest(".lb-hdr__dd")) {
      openItems.forEach(function (o) { o.classList.remove("is-open"); o.querySelector("a").setAttribute("aria-expanded", "false"); });
      document.querySelectorAll("[data-lb-dd-sub].is-open").forEach(function (o) { o.classList.remove("is-open"); });
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") document.querySelectorAll("[data-lb-dd].is-open").forEach(function (o) { o.classList.remove("is-open"); });
  });

  /* ---------- Scroll reveal (smooth section/card entrances) ---------- */
  var REVEAL_GROUPS = [
    ".lb-cats__grid", ".lb-age__grid", ".lb-deals__list", ".lb-offers__grid",
    ".lb-deliv__grid", ".lb-trust__row", ".lb-best .lb-grid", ".lb-shop__grid",
    ".lb-pdp__related .lb-grid", ".lb-ft__cols", ".lb-coupons__grid"
  ];
  var REVEAL_SINGLES = [
    ".lb-head", ".lb-cats__title", ".lb-age__head", ".lb-deals__head",
    ".lb-bundle__box", ".lb-gc__box", ".lb-app__box", ".lb-deliv__title",
    ".lb-deals__spot", ".lb-pdp__gallery", ".lb-pdp__info"
  ];
  var _io = null;
  function revealScan(scope) {
    scope = scope || document;
    if (!("IntersectionObserver" in window)) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.documentElement.classList.add("lb-anim");
    if (!_io) {
      _io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { window.__lbIoFired = true; en.target.classList.add("lb-inview"); _io.unobserve(en.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    }
    function mark(el, delay) {
      if (el.classList.contains("lb-reveal")) return;
      el.classList.add("lb-reveal");
      if (delay) el.style.setProperty("--lb-d", delay + "ms");
      _io.observe(el);
    }
    REVEAL_SINGLES.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (el) { mark(el, 0); });
    });
    REVEAL_GROUPS.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (grid) {
        var kids = grid.children;
        for (var i = 0; i < kids.length; i++) mark(kids[i], Math.min(i, 7) * 55);
      });
    });
    /* safety: never leave content hidden (slow IO, odd embeds, etc.) */
    setTimeout(function () {
      scope.querySelectorAll(".lb-reveal:not(.lb-inview)").forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 800) * 1.5) el.classList.add("lb-inview");
      });
    }, 1200);
    /* if the observer never fired at all (broken env), reveal everything */
    setTimeout(function () {
      if (window.__lbIoFired) return;
      document.querySelectorAll(".lb-reveal:not(.lb-inview)").forEach(function (el) { el.classList.add("lb-inview"); });
    }, 4000);
  }
  if (document.readyState !== "loading") revealScan();
  else document.addEventListener("DOMContentLoaded", function () { revealScan(); });
  /* re-scan freshly swapped content (AJAX shop filtering) */
  document.addEventListener("lb:content", function (e) { revealScan(e.detail && e.detail.root); });
  document.addEventListener("shopify:section:load", function (e) { revealScan(e.target); });

  /* ---------- Fixed header (+ fixed coupon bar): offset content so nothing hides ---------- */
  function applyHeaderOffset() {
    var header = document.querySelector("[data-lb-header].lb-hdr--fixed");
    var coupon = document.querySelector(".lb-coupons--fixed");
    if (!header && !coupon) { document.body.style.paddingTop = ""; return; }
    var hH = header ? header.offsetHeight : 0;
    var total = hH;
    if (coupon) { coupon.style.top = hH + "px"; total += coupon.offsetHeight; }
    document.body.style.paddingTop = total + "px";
    document.documentElement.style.setProperty("--lb-hdr-h", hH + "px");
    document.documentElement.style.setProperty("--lb-fixed-total", total + "px");
  }
  function initFixedHeader() {
    var header = document.querySelector("[data-lb-header].lb-hdr--fixed");
    var coupon = document.querySelector(".lb-coupons--fixed");
    if (!header && !coupon) return;
    applyHeaderOffset();
    window.addEventListener("resize", applyHeaderOffset);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(applyHeaderOffset);
      if (header) ro.observe(header);
      if (coupon) ro.observe(coupon);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(applyHeaderOffset);
    // recompute when the coupon drawer expands/collapses
    if (coupon) { var acc = coupon.querySelector("details"); if (acc) acc.addEventListener("toggle", applyHeaderOffset); }
  }
  if (document.readyState !== "loading") initFixedHeader();
  else document.addEventListener("DOMContentLoaded", initFixedHeader);
  // Theme editor: re-measure when a section is re-rendered
  document.addEventListener("shopify:section:load", applyHeaderOffset);
  document.addEventListener("shopify:section:unload", applyHeaderOffset);

  /* ---------- Mobile: hide the header (+ coupon bar) on scroll down, reveal on scroll up ---------- */
  function initHideOnScroll() {
    var header = document.querySelector("[data-lb-header].lb-hdr--fixed");
    if (!header) return;
    var root = document.documentElement;
    var lastY = Math.max(0, window.pageYOffset || 0);
    var ticking = false;
    var HIDE_PAST = 120;  /* don't hide until scrolled at least this far */
    var DELTA = 6;        /* ignore sub-pixel / jitter scrolling */
    function isMobile() { return window.matchMedia("(max-width: 900px)").matches; }
    function update() {
      ticking = false;
      var y = Math.max(0, window.pageYOffset || 0);
      if (!isMobile()) { root.classList.remove("lb-chrome-hidden"); lastY = y; return; }
      /* never hide while a drawer / menu / sheet is open */
      if (root.classList.contains("lb-drawer-lock")) { lastY = y; return; }
      var diff = y - lastY;
      if (Math.abs(diff) < DELTA) return;         /* keep lastY; let small moves accumulate */
      if (diff > 0 && y > HIDE_PAST) root.classList.add("lb-chrome-hidden");
      else if (diff < 0) root.classList.remove("lb-chrome-hidden");
      lastY = y;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener("resize", function () {
      if (!isMobile()) root.classList.remove("lb-chrome-hidden");
    });
  }
  if (document.readyState !== "loading") initHideOnScroll();
  else document.addEventListener("DOMContentLoaded", initHideOnScroll);

  /* ---------- Bottom clearance: reserve space for the tab bar AND whichever
       contextual bar is currently visible above it (cart bar, or the product
       page's sticky add-to-cart bar). Without the contextual bar's height the
       last row of products / related items ends up hidden behind it. ---------- */
  function applyBottomClearance() {
    var tb = document.querySelector("[data-lb-tabbar]");
    var tabH = (tb && getComputedStyle(tb).display !== "none") ? tb.offsetHeight : 0;
    document.documentElement.style.setProperty("--lb-tabbar-h", tabH + "px");
    // Contextual bars share the same bottom position (they sit directly above the
    // tab bar), so clearance is the tallest visible one, not their sum.
    var ctxH = 0;
    document.querySelectorAll(".lb-cartbar.is-visible, .lb-pdp__staybar.is-visible").forEach(function (el) {
      if (getComputedStyle(el).display !== "none") ctxH = Math.max(ctxH, el.offsetHeight);
    });
    var total = tabH + ctxH;
    document.body.style.paddingBottom = total ? total + "px" : "";
  }
  function initBottomClearance() {
    applyBottomClearance();
    window.addEventListener("resize", applyBottomClearance);
    window.addEventListener("orientationchange", applyBottomClearance);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(applyBottomClearance);
    // Recompute whenever a contextual bar slides in/out (class or inline transform changes).
    if (window.MutationObserver) {
      document.querySelectorAll(".lb-cartbar, .lb-pdp__staybar").forEach(function (b) {
        new MutationObserver(applyBottomClearance).observe(b, {
          attributes: true, attributeFilter: ["class", "style"]
        });
      });
    }
  }
  if (document.readyState !== "loading") initBottomClearance();
  else document.addEventListener("DOMContentLoaded", initBottomClearance);

  /* ---------- Signup / newsletter bar for logged-out visitors ---------- */
  function initSignupBar() {
    var su = document.querySelector("[data-lb-signup]");
    if (!su) return; // not rendered => customer is logged in
    var KEY = "lb-signup-dismissed";
    function dismissed() { try { return localStorage.getItem(KEY) === "1"; } catch (e) { return false; } }
    function remember() { try { localStorage.setItem(KEY, "1"); } catch (e) {} }
    function close() { su.classList.remove("is-open"); remember(); }

    su.querySelectorAll("[data-lb-signup-close]").forEach(function (b) {
      b.addEventListener("click", close);
    });

    if (su.getAttribute("data-lb-posted") === "true") {
      // Came back from a successful subscribe — show the thanks, don't nag again.
      su.classList.add("is-open");
      remember();
      return;
    }
    if (su.hasAttribute("data-lb-delayed") && !dismissed()) {
      setTimeout(function () {
        // Don't interrupt a shopper who already has items (cart bar showing).
        if (document.querySelector(".lb-cartbar.is-visible")) return;
        su.classList.add("is-open");
      }, 6000);
    }
  }
  if (document.readyState !== "loading") initSignupBar();
  else document.addEventListener("DOMContentLoaded", initSignupBar);
})();
